import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalizationModule } from '@abp/ng.core';
import { safeJsonParse } from 'src/core/helpers/json-parse.helper';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { TestNotificationPayload } from 'src/core/models/notification/test-notification.payload';
import { NotificationItemComponent } from '../../models/notification-item-component.model';

/**
 * Renders `type === 'TestNotification'` — manually triggered via the bell popover's "Test" button, used to
 * verify the notification pipeline (persisted list + SignalR push) end-to-end from the UI.
 */
@Component({
  selector: 'app-test-notification',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationModule],
  templateUrl: './test-notification.component.html',
  styleUrl: './test-notification.component.scss',
})
export class TestNotificationComponent implements NotificationItemComponent {
  private _notification!: NotificationDto;
  sentByUserName = '';

  @Input({ required: true })
  set notification(value: NotificationDto) {
    this._notification = value;
    this.sentByUserName = this.resolveSentByUserName(value.payload);
  }
  get notification(): NotificationDto {
    return this._notification;
  }

  private resolveSentByUserName(payload: string): string {
    const parsed = safeJsonParse<TestNotificationPayload>(payload);
    return parsed?.sentByUserName ?? parsed?.SentByUserName ?? '';
  }
}
